import { dataService } from '../../data';

import { DataObject, ObjectOptions } from "../base";
import { CreateObject } from "../item";

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

const _schema = {
    "name": "ADDRESS",
    "fields": [
        { name: "formatted", type: "string" },
        { name: "door", type: "string" },                
        { name: "latitude", type: "number" },
        { name: "longitude", type: "number" },
        { name: "accuracy", type: "number" },
        { name: "timezone", type: "string", default: "UTC" },
        { name: "street", type: "string" },
        { name: "number", type: "string" },
        { name: "zipcode", type: "string" },
        { name: "town", type: "string" },
        { name: "province", type: "string" },
        { name: "country", type: "string" }
    ],
    relate: []
} as const;

const _AddressClass = CreateObject(_schema);
if (!_AddressClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class Address extends _AddressClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): Address {
        return this._Copy(store) as Address;
    }

    private _GetAddressLines(): { line1: string, line2: string } {
        const _street = String(this.street || '').trim();
        const _number = String(this.number || '').trim();
        const _zipcode = String(this.zipcode || '').trim();
        const _town = String(this.town || '').trim();
        const _province = String(this.province || '').trim();

        let _addressLine1 = [_street, _number].filter((item) => item.length > 0).join(', ');
        let _addressLine2 = [_zipcode, _town, _province].filter((item) => item.length > 0).join(' ');

        if (_addressLine1.length === 0 && _addressLine2.length === 0){
            const _formattedParts = String(this.formatted || '')
                .split(',')
                .map((item) => item.trim())
                .filter((item) => item.length > 0);

            if (_formattedParts.length > 0){
                _addressLine1 = _formattedParts.shift() || '';
                _addressLine2 = _formattedParts.join(', ');
            }
        }

        return { line1: _addressLine1, line2: _addressLine2 };
    }

    get line1(): string {
        return this._GetAddressLines().line1;
    }

    get line2(): string {
        return this._GetAddressLines().line2;
    }
}

